import WithRender from "../../templates/base/upload.html";
import { mapGetters, mapActions } from "vuex";
import ProgressBar from "vue-progressbar-component";
import { pathOr } from "ramda";

export default WithRender({
  components: {
    ProgressBar
  },
  computed: {
    ...mapGetters([
      "getShowUpload",
      "getSelectionId",
      "getShowPreviewInUpload",
      "getIsPackingEnabled",
      "getIsPreflighPitstop",
      "getPitstopFileIsLoading",
      "getPitstopFileStatusResponse",
      "getTimer",
      "getUrl",
      "getUploads",
      "getUploadedFileStatusByHash",
      "getUploadedFilesStatus",
      "getIsMobile",
      "getIsMyAccount",
      "getUploadedInMyAccount",
      "getIsPreflightCheckLoadingByPP",
      "getMyAccountUploadedFiles",
      "getSelectedOption",
      "getUploadForProductPart",
      "getFileParameters",
      "getProductPartUploadedFileName",
      "getSelectedFormat"
    ]),
    uploadedFileData: function () {
      const hash = this.getUploadForProductPart(this.propsData.code)
        .uploadedFileHash;
      return this.getUploadedFileStatusByHash(hash);
    }
  },
  methods: {
    ...mapActions([]),
    getAttribute: function (key) {
      return this.getUploadForProductPart(this.propsData.code)[key];
    },
    getIsPreflightCheckLoadingForProductPart: function () {
      return this.getIsPreflightCheckLoadingByPP(this.propsData.code);
    },
    getAreLinksExpired: function () {
      if (this.getUploadedInMyAccount) {
        return false;
      }
      const uploadDate = pathOr(
        null,
        ["upload_date"],
        this.getMyAccountUploadedFiles(this.propsData.code)
      );

      const uploadDateToDateObj = new Date(uploadDate);
      const today = new Date();
      const threeMonthsAgo = new Date();

      threeMonthsAgo.setMonth(today.getMonth() - 3);

      if (uploadDateToDateObj <= threeMonthsAgo) {
        return true;
      } else {
        return false;
      }
    }
  },
  props: ["propsData", "alwaysShow"]
});
